import React, { useState } from 'react';
import { Form, Input, Tag, Stack } from 'rsuite';
import { t } from 'i18next'
import { Button } from '@/client/components/Controls';
import { Capabilities, hasPermission } from '@/shared';

// Props für ClientList
interface ClientListProps {
    name: string
    value: string[]
    onChange: (value: string[]) => void
    error?: string
    readOnly?: boolean
}

// ClientList component as Form.Control
const ClientList: React.FC<ClientListProps> = ({ name, value, onChange, error, readOnly }) => {
    const [inputValue, setInputValue] = useState('')
    const [editingIndex, setEditingIndex] = useState<number | null>(null)

    const addClient = () => {
        if (editingIndex !== null) {
            const updated = [...value]
            updated[editingIndex] = inputValue.trim()
            onChange(updated)
            setEditingIndex(null)
        } else {
            onChange([...value, inputValue.trim()])
            editClient(value.length)
        }
        setInputValue('')
    }

    const editClient = (index: number) => {
        setInputValue(value[index])
        setEditingIndex(index)
    }

    const deleteClient = (index: number) => {
        const updated = value.filter((_, i) => i !== index)
        onChange(updated)
        if (editingIndex === index) {
            setInputValue('')
            setEditingIndex(null)
        }
    }

    return (
        <Form.Group controlId={name} className="project-client-list">
            <Form.Label>
                {t('Clients')}
                {hasPermission(Capabilities.project_write) && <Button onClick={() => { setEditingIndex(null); addClient() }} style={{ margin: '-3px 0 0 5px' }}>+</Button>}
            </Form.Label>
            <Stack
                spacing={6}
                direction='column'
                alignItems='flex-start'
                className="stack-edit-list"
            >
                {value?.map((client, index) => (
                    <Tag
                        key={index}
                        closable={hasPermission(Capabilities.project_write) && index >= 0}
                        onClick={() => editClient(index)}
                        onClose={() => deleteClient(index)}
                    >
                        {
                            editingIndex === index
                                ? <Input
                                    value={inputValue}
                                    onChange={setInputValue}
                                    placeholder={t('Enter client name')}
                                    onPressEnter={addClient}
                                    readOnly={!hasPermission(Capabilities.project_write)}
                                    autoFocus
                                    onBlur={() => { addClient(); setEditingIndex(null) }}
                                />
                                : client
                        }
                    </Tag>
                ))}
                {!value?.length && <Tag>{t('No clients found.')}</Tag>}
            </Stack>
            {error && <Form.ErrorMessage>{error}</Form.ErrorMessage>}
        </Form.Group>
    )
}

export default ClientList
